<template>
  <div class="view-more" :class="{ 'is-open': showContent, 'is-close': !showContent }">
    <div class="view-more__content">
      <template v-if="isLazy || showContent">
        <slot name="default"></slot>
      </template>
    </div>
    <div v-if="isApply" class="view-more__button-wrap">
      <button class="btn btn-white btn-size-s btn-view-more" @click.prevent.stop="onView">{{isOpen ? textClose : textOpen}}</button>
    </div>
  </div>
</template>

<script>
const L10n = window.app.L10n
export default {
  name: 'ViewMore',
  props: {
    textOpen: { type: String, default: L10n('view-more') },
    textClose: { type: String, default: L10n('view-less') },
    isApply: { type: Boolean, default: true },
    isLazy: { type: Boolean, default: true }
  },
  data () {
    return {
      isOpen: false
    }
  },
  computed: {
    showContent () {
      return this.isOpen || !this.isApply
    }
  },
  methods: {
    onView () {
      this.isOpen = !this.isOpen
      this.$emit(`on${this.isOpen ? 'More' : 'Less'}`)
    }
  }
}
</script>

<style lang="stylus">
.view-more{
  position relative
  &.is-open{
    .view-more__content{
      display: block
    }
  }
  &.is-close{
    .view-more__content{
      display: none
    }
  }
}
.view-more__button-wrap{
  text-align center
  position relative
  z-index 5
  &:before {
    display block
    content ""
    height 2px
    background #eef2f4
    margin -1px 0 0
    position absolute
    top 50%
    left 0
    right 0
    z-index -1
  }
}
</style>
